import React, { Component } from 'react';
import { connect } from 'react-redux';

import { clearError, removeAccountReport, removeAccount } from '../../store/actions/accountActions';
import { removeAgentReport } from '../../store/actions/agentActions';

import { Modal } from './Modal';
import { returnHostUrl } from '../../util/axiosHelper';
import { buttonText } from '../../util/constants';

export class ModalHandler extends Component {
  constructor(props) {
    super(props);

    this.clearErrors = this.clearErrors.bind(this);
    this.clickRedirect = this.clickRedirect.bind(this);
  }

  clearErrors() {
    this.props.removeAccountReport();
    this.props.removeAgentReport();
    this.props.clearError();
    if (this.props.crossDomainData) {
      this.props.removeAccount();
    }
  }

  clickRedirect() {
    const accountNumber = this.props.crossDomainData.account.accountNumber;
    let targetUrl;
    if (returnHostUrl().isResi) {
      targetUrl = `${returnHostUrl().cobrowseSMBUI}?ACCTNUM=${encodeURIComponent(accountNumber)}`;
    } else {
      targetUrl = `${returnHostUrl().cobrowseResiUI}?ACCTNUM=${encodeURIComponent(accountNumber)}`;
    }
    window.location.replace(targetUrl);
  }

  render() {
    const { accountError, accountReportError, agentError, agentReportError, crossDomainData } = this.props;
    return (
      <Modal
        message={
          accountError ||
          agentError ||
          accountReportError ||
          agentReportError ||
          (crossDomainData && crossDomainData.message)
        }
        redirectButtonText={returnHostUrl().isResi ? buttonText.redirectToBusiness : buttonText.redirectToResidential}
        crossDomainData={crossDomainData}
        onButtonClick={this.clearErrors}
        onRedirectClick={this.clickRedirect}
      />
    );
  }
}

export function mapStateToProps({
  account: { error: accountError, crossDomainData },
  agent: { error: agentError },
  targetAccountReport: { error: accountReportError },
  targetAgentReport: { error: agentReportError },
}) {
  return {
    accountError,
    accountReportError,
    agentError,
    agentReportError,
    crossDomainData,
  };
}
export default connect(mapStateToProps, {
  clearError,
  removeAgentReport,
  removeAccountReport,
  removeAccount,
})(ModalHandler);
